module.exports = __webpack_public_path__ + "media/images/autopilot/rocket-837b33a094a5aa6921171adbbc613269.png";